import { useTranslations } from '@vocab/react';
import { Stack } from 'braid-design-system';
import { useEffect } from 'react';

import translations from 'src/App/App.vocab';
import { RemoveUserFromAccountCard } from 'src/App/Components/RemoveUserFromAccountCard/RemoveUserFromAccountCard';
import {
  SkeletonEditUserDetails,
  SkeletonEditUserPermissions,
} from 'src/App/Components/Skeleton/SkeletonEditUser/SkeletonEditUser';
import {
  FlowKey,
  UserFormProvider,
} from 'src/App/Components/UserFormProvider/UserFormProvider';
import { PageLayout } from 'src/App/Layouts/PageLayout/PageLayout';
import { ErrorPage } from 'src/App/Pages/ErrorPage/ErrorPage';
import {
  CURRENT_PAGE_EDIT_USER,
  PAGE_EDIT_USER_DISPLAYED,
} from 'src/constants/tracking';
import { useHirerAccountUser } from 'src/hooks/use-hirer-account-user';
import { useTracking } from 'src/hooks/use-track-page-load';
import { useConfig } from 'src/modules/ConfigProvider';

import { UserDetailsCard } from './UserDetailsCard/UserDetailsCard';

export const EditUserDetailsPage = () => {
  const { data: user, loading: userLoading, error } = useHirerAccountUser();
  const { site, locale } = useConfig();
  const { trackView } = useTracking();
  const { t } = useTranslations(translations);

  useEffect(() => {
    if (user) {
      trackView(PAGE_EDIT_USER_DISPLAYED, CURRENT_PAGE_EDIT_USER, {
        memberId: user?.id,
      });
    }
  }, [trackView, user]);

  if (error) {
    return <ErrorPage error={error} site={site} locale={locale} />;
  }

  return (
    <PageLayout heading={t('Edit team member title')}>
      {!user || userLoading ? (
        <Stack space="xlarge">
          <SkeletonEditUserDetails />
          <SkeletonEditUserPermissions />
        </Stack>
      ) : (
        <Stack space="xlarge">
          <UserDetailsCard user={user} />
          <UserFormProvider flowKey={FlowKey.Edit} userToEdit={user} />
          <RemoveUserFromAccountCard userToEdit={user} />
        </Stack>
      )}
    </PageLayout>
  );
};
